

import React, { memo } from 'react';

import ImageWithContent from '../../Image/containers/ImageWithContent';

import '../styles/_avatar.scss';
import {
  AVATAR_DEFAULT_HEIGHT, AVATAR_DEFAULT_ICON_BACKGROUND,
  AVATAR_DEFAULT_ICON_COLOUR,
  AVATAR_DEFAULT_IMAGE_ICON,
  AVATAR_DEFAULT_WIDTH } from
'../constants/avatarDefaultProps';







const Avatar = (props) => {
  const {
    title,
    subtitle,
    imageUrl,
    width = AVATAR_DEFAULT_WIDTH,
    height = AVATAR_DEFAULT_HEIGHT,
    circular = true,
    defaultImageIcon = AVATAR_DEFAULT_IMAGE_ICON,
    defaultIconColour = AVATAR_DEFAULT_ICON_COLOUR,
    defaultIconBackground = AVATAR_DEFAULT_ICON_BACKGROUND,
    ...imageProps
  } = props;

  return (
    <ImageWithContent
      className="avatar"
      {...imageProps}
      imageUrl={imageUrl}
      width={width}
      height={height}
      circular={circular}
      defaultImageIcon={defaultImageIcon}
      defaultIconColour={defaultIconColour}
      defaultIconBackground={defaultIconBackground}>

      {title && <div className="avatar__title">{title}</div>}

      {subtitle && <div className="avatar__subtitle">{subtitle}</div>}
    </ImageWithContent>);

};

export default memo(Avatar);